import Homework from "./homework.jsx";
import ClassWork from "./class-work.jsx";
import Community from './community'
import Player from "./player.jsx";
import Baize from "./baize.jsx";
import ConfigureTopic from './configure-topic.jsx'
import { Environment, getEnv, getTemplateData  } from "../../lib/xes/xes.js";
import React from "react";
import BrowserModal from "../browser-modal/browser-modal.jsx";

const panels = {
  [Environment.HOMEWORK]: Homework,
  [Environment.CLASSWORK]: ClassWork,
  [Environment.PLAYER]: Player,
  [Environment.COMMUNITY]: Community,
  [Environment.CONFIGURETOPIC]: ConfigureTopic,
  [Environment.BAIZE]: Baize
}
export default () => {
  let env = getEnv()
  let Panel = panels[env]
  return (
    <React.Fragment>
      <Panel />
      <BrowserModal></BrowserModal>
    </React.Fragment>
  )
}